import { gql } from "@apollo/client";

export default gql`
  fragment ConnectionFragment on connection {
    id
    sourceAccount {
      id
      accountName
      logo
    }
    targetAccount {
      id
      accountName
      logo
      notes
    }
  }
`;
